export const MobileShare = (props: any) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="currentColor"
		{...props}
	>
		<g clip-path="url(#clip0_10_5)">
			<path d="M18 16V11.2C18 10.8817 17.8815 10.5765 17.6705 10.3515C17.4595 10.1264 17.1734 10 16.875 10H15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M6 16L6 11.2C6 10.8817 6.11853 10.5765 6.32951 10.3515C6.54048 10.1264 6.82663 10 7.125 10H9" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M12 4V13.75" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M15 7L12 4L9 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M6 12.25V18.65C6 19.0743 6.15804 19.4813 6.43934 19.7814C6.72064 20.0814 7.10218 20.25 7.5 20.25H16.5C16.8978 20.25 17.2794 20.0814 17.5607 19.7814C17.842 19.4813 18 19.0743 18 18.65V12.25" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</g>
		<defs>
			<clipPath id="clip0_10_5">
				<rect width="18" height="18" transform="translate(3 3)"/>
			</clipPath>
		</defs>
	</svg>
);
